module.exports = __webpack_public_path__ + "static/img/online-xin.cd06ff42.png";